import { callApi } from './config/callApi'

export const getUser = async (): Promise<any> => {
  return callApi({
    method: 'get',
    url: '/user',
  })
}

export const getAllUser = async (): Promise<any> => {
  return callApi({
    method: 'get',
    url: '/user/all',
  })
}
